@if (cta) {
  <div class="cta">
    @if (cta.color) {
      @if (cta.routerLink) {
        <a
          class="cta__link qs-btn qs-btn--{{ cta.color }} qs-btn--icon-{{ cta.icon }}"
          [class.qs-btn--icon]="cta.icon"
          [routerLink]="cta.routerLink">

          {{ cta.label }}
        </a>
      }

      @if (cta.fragment) {
        <a
          class="cta__link qs-btn qs-btn--{{ cta.color }} qs-btn--icon-{{ cta.icon }}"
          [class.qs-btn--icon]="cta.icon"
          [routerLink]=""
          [fragment]="cta.fragment"
          (click)="goToAnchor(cta.fragment)">

          {{ cta.label }}
        </a>
      }

      @if (cta.href && !cta.download) {
        <a
          class="cta__link qs-btn qs-btn--{{ cta.color }} qs-btn--icon-{{ cta.icon }}"
          [class.qs-btn--icon]="cta.icon"
          [attr.target]="cta.target || (cta.download ? '_blank' : '_self')"
          [attr.rel]="cta.target === '_blank' ? 'nofollow' : cta.rel || ''"
          [href]="cta.href | safe:'bypassSecurityTrustUrl'"
          (click)="handleAnalytics($event, cta)">

          {{ cta.label }}
        </a>
      }

      @if (cta.href && cta.download) {
        <a
          class="cta__link qs-btn qs-btn--{{ cta.color }} qs-btn--icon-{{ cta.icon }}"
          [class.qs-btn--icon]="cta.icon"
          [attr.download]="cta.download"
          [attr.target]="cta.target || (cta.download ? '_blank' : '_self')"
          [attr.rel]="cta.target === '_blank' ? 'nofollow' : cta.rel || ''"
          [href]="cta.href | safe:'bypassSecurityTrustUrl'"
          (click)="handleAnalytics($event, cta)">

          {{ cta.label }}
        </a>
      }
    }

    @if (!cta.color) {
      @if (cta.routerLink) {
        <a
          class="cta__link"
          [class.qs-btn--icon]="cta.icon"
          [routerLink]="cta.routerLink">

          {{ cta.label }}
        </a>
      }

      @if (cta.fragment) {
        <a
          class="cta__link qs-btn qs-btn--{{ cta.color }} qs-btn--icon-{{ cta.icon }}"
          [class.qs-btn--icon]="cta.icon"
          [routerLink]=""
          [fragment]="cta.fragment"
          (click)="goToAnchor(cta.fragment)">

          {{ cta.label }}
        </a>
      }

      @if (cta.href) {
        <a
          class="cta__link"
          [class.qs-btn--icon]="cta.icon"
          [attr.download]="cta.download"
          [attr.target]="cta.target || (cta.download ? '_blank' : '_self')"
          [attr.rel]="cta.target === '_blank' ? 'nofollow' : cta.rel || ''"
          [href]="cta.href | safe:'bypassSecurityTrustUrl'"
          (click)="handleAnalytics($event, cta)">

          {{ cta.label }}
        </a>
      }

      <span class="qs-icon qs-icon--tiny qs-icon--href-arrow-right"></span>
    }
  </div>
}
